import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ReportLevelEnum } from "../../model/reporting/contract/reporting-contract";
import { ReportJob } from "../../model/reporting/report-job.model";
import { createUrl } from "../api.util";
import { GenericApi } from "../generic.api";

// Convenience Type
type T = ReportJob;

@Injectable({
  providedIn: "root",
})
export class ReportingJobApi extends GenericApi<T> {
  public path = "report-job";

  constructor(public httpClient: HttpClient) {
    super(httpClient);
  }

  readonly createReportJob = (data: {
    documentId: number;
    formGroupInstanceId: number;
    reportLevel: ReportLevelEnum;
    contactExternalId?: string;
  }): Observable<{ success: boolean }> => {
    return this.httpClient.post<{ success: boolean }>(createUrl(this.path), data);
  };

  readonly getReportAccess = (token: string): Observable<{ success: boolean; message: string }> => {
    return this.httpClient.get<{ success: boolean; message: string }>(
      createUrl(this.path, "report-access", token),
    );
  };
}
